import { englishMovies } from "../video/videoUrl";
import { IChannel } from "./IChannel";
export class EnglishChannel implements IChannel {
    channelMovies: any[];
    moviesNum: number;

    constructor(public setVideoSrc: (value: string) => void) {
        this.channelMovies = englishMovies;
        this.moviesNum = this.channelMovies.length;
    }

    setMovieByIndex(index: number) {
        this.setVideoSrc(this.channelMovies[index]);
    }

    getMoviesNum() {
        return this.moviesNum;
    }

    getIconLabelByIndex(index: number) {
        let label: string;
        if (index > this.moviesNum) {
            label = "none";
        } else {
            label = `english_0${index}`;
        }
        return label;
    }
}
